/**
 * * Модель элемента списка уровней сложности
 */
export default class UpsertDifficultyToNamespaceIdRequestItem  {
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Цвет
	 */
	Color!: string;
	/**
	 * * Номер уровня если следует его обновить
	 */
	DifficultyId?: string;
	/**
	 * * Выставлен по умолчанию
	 */
	IsDefault: boolean = false;
	/**
	 * * Описание
	 */
	Description!: string;
	/**
	 * * Порядковый номер
	 */
	Number!: number;
	constructor(obj?: Partial<UpsertDifficultyToNamespaceIdRequestItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
